var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-skeleton-loader',{staticClass:"mb-3",attrs:{"loading":_vm.loading,"type":"actions"}},[_c('v-row',{attrs:{"dense":""}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }